import React from 'react';
import { Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { tooltipContent, TooltipEntry } from './tooltipContent';

interface MetricTooltipProps {
  metric: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  iconSize?: number;
}

export const MetricTooltip: React.FC<MetricTooltipProps> = ({
  metric,
  side = 'top',
  iconSize = 14,
}) => {
  const entry: TooltipEntry | undefined = tooltipContent[metric];
  if (!entry) return null;

  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center align-middle ml-1 text-muted-foreground hover:text-foreground transition-colors"
            aria-label={`Info about ${entry.title}`}
          >
            <Info size={iconSize} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className="max-w-[280px] p-3 space-y-1.5"
          sideOffset={6}
        >
          <p className="font-semibold text-sm">{entry.title}</p>
          <p className="text-xs leading-relaxed">{entry.description}</p>
          {entry.interpretation && (
            <p className="text-xs leading-relaxed text-muted-foreground italic">
              💡 {entry.interpretation}
            </p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
